var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f2c376ba-0224-4749-bbad-e6d36182b9b7",
    "data-name": "C-wires layered OFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 466.91 164.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".C-wire-channel,.f21387dd-2d6b-4cbb-9606-619fb1eeeb48{fill:none;}.C-wire-channel{stroke:#d2e4f9;stroke-linecap:round;stroke-linejoin:round;stroke-width:9px;}.f21387dd-2d6b-4cbb-9606-619fb1eeeb48{stroke:#b290d1;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bdd6b1df-5cda-4066-a828-ecd1b66dec5c",
    "data-name": "Channel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M460.8,46.51,427.36,66.35a4,4,0,0,0-2,3.44V114a4,4,0,0,1-2,3.48l-58,33.1a3.92,3.92,0,0,1-2,.53H281.09a4,4,0,0,0-2.1.6l-10.42,6.45a4,4,0,0,1-4.13,0L6.11,6.23"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ba35d823-ce53-4e13-a661-8c33c81f17a4",
    "data-name": "OFF"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M460.8,46.51,427.36,66.35a4,4,0,0,0-2,3.44V114a4,4,0,0,1-2,3.48l-58,33.1a3.92,3.92,0,0,1-2,.53H281.09a4,4,0,0,0-2.1.6l-10.42,6.45a4,4,0,0,1-4.13,0L6.11,6.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f21387dd-2d6b-4cbb-9606-619fb1eeeb48",
    d: "M460.8,46.51,427.36,66.35a4,4,0,0,0-2,3.44V114a4,4,0,0,1-2,3.48l-58,33.1a3.92,3.92,0,0,1-2,.53H281.09a4,4,0,0,0-2.1.6l-10.42,6.45a4,4,0,0,1-4.13,0L6.11,6.23"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivated);
export default __webpack_public_path__ + "static/media/activated.3a6487cd.svg";
export { ForwardRef as ReactComponent };